<template>
	<div>
		<a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" @submit.native.prevent="handleSubmit"
			class="product-tab">
			<!-- 工厂名称 -->
			<!-- v-model="baseInfo.businessId" -->
			<a-form-item :label="`${ifFacOrBr=='1'?'工厂名称':'品牌名称'}`">
				<a-select :disabled="baseInfo.lang === 'EN'" v-decorator="['businessId',{ rules: [{ required: true, message: '请选择' }] }]"
						  :placeholder="ifFacOrBr == '1' ? '请选择工厂名称' : '请选择品牌名称'"
						  showSearch :filterOption="filterBusiness" @change="handleFormChange(true)">
					<a-select-option v-for="item in companyList" :key="item.businessId" :value="item.businessId">
						{{ item.businessName }}
					</a-select-option>
				</a-select>
			</a-form-item>

			<!-- 工厂列表缩略图 -->
			<a-form-item :label="`${ifFacOrBr=='1'?'工厂列表缩略图':'品牌列表缩略图'}`" :auto-link="false">
				<div v-decorator="['factoryThumbnail', {rules: [{ required: true, message: '请上传' }]}]"
					style="display: none;"></div>

				<div style="display: flex;align-items: center;">
					<div v-if="baseInfo.factoryThumbnail">
						<viewer :images="[baseInfo.factoryThumbnail]">
							<div class="er_content">
								<img class="er_content_img" :src="img"
									v-for="(img,index) in [baseInfo.factoryThumbnail]" :key="index">
							</div>
						</viewer>
					</div>
					<div class="again_upload_box ml12">
					<a-spin :spinning="uploadingThumbnail" size="small">
					<input type="file" accept="image/*" @change="handleUploadThumbnail" :disabled="uploadingThumbnail" />
						<i class="el-icon-box again_upload_icon"></i>
						<div class="bold" style="width: 100px">
							{{ baseInfo.factoryThumbnail ? "重新上传" : "上传图片" }}
						</div>
					</a-spin>
					</div>
				</div>
				<div>只能上传jpg/png格式文件，文件不能超过3M</div>
			</a-form-item>

			<!-- 工厂头图 -->
		<a-form-item :label="`${ifFacOrBr=='1'?'工厂头图':'品牌详情页头图'}`" :auto-link="false">
			<div v-decorator="['factoryImage', { rules: [{ validator: validateFactoryImage ,required: true, message: '请上传'}] }]" style="display: none;"></div>
			<div style="display: flex;align-items: flex-start;flex-wrap: wrap;">
				<div v-for="(img, index) in baseInfo.factoryImages" :key="index"
					style="position: relative; margin-right: 12px; margin-bottom: 12px;">
					<viewer :images="baseInfo.factoryImages">
						<div class="er_content">
							<img class="er_content_img" :src="img" :key="index">
						</div>
					</viewer>
					<a-icon type="close-circle"
							v-if="ifFacOrBr=='1'"
						style="position: absolute; top: -8px; right: -8px; font-size: 18px; color: #f5222d; cursor: pointer; z-index: 10;"
						@click="deleteFactoryImage(index)" />
				</div>
				<div class="again_upload_box ml12" v-if="(ifFacOrBr=='1' ? (baseInfo.factoryImages || []).length < 3 : true)">
					<a-spin :spinning="uploadingImage" size="small">
						<input type="file" accept="image/*" :multiple="ifFacOrBr=='1'" @change="handleUploadImage" :disabled="uploadingImage" />
						<i class="el-icon-box again_upload_icon"></i>
						<div class="bold" style="width: 100px">
							{{ ifFacOrBr=='1' ? '还可选择 ' + (3 - (baseInfo.factoryImages || []).length) + ' 张' : '上传头图' }}
						</div>
					</a-spin>
				</div>
			</div>
			<div>最多上传{{ ifFacOrBr=='1' ? '3' : '1' }}张，只能上传jpg/png格式文件，文件不能超过3M</div>
		</a-form-item>

			<!-- 品类 -->
			<a-form-item label="品类" :auto-link="false">
				<div v-decorator="['categoryIds', {
			  rules: [{ required: true, message: '请选择品类' }]
			}]" style="display: none;"></div>
					<a-select placeholder="请选择品类" show-search :disabled="baseInfo.lang === 'EN'"
						option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.plText" @change="handleFormChange">
						<a-select-option v-for="(item) of availablePinlei" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="margin-top:8px;" type="primary" @click="addPL" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>

				<div ref="dragContainerPL" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of plList" :key="item.tagId" :data-tag-id="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<div class="right" v-if="baseInfo.lang !== 'EN'" @click="deletePaperSize(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00',cursor:'pointer' }" type="delete" />
						</div>
					</div>
				</div>
			</a-form-item>

			<!-- 工艺 -->
			<a-form-item label="工艺" :auto-link="false">
				<div v-decorator="['craftsmanshipIds', {
					  rules: [{ required: true, message: '请选择工艺' }]
					}]" style="display: none;"></div>
					<a-select placeholder="请选择工艺" show-search :disabled="baseInfo.lang === 'EN'"
						option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.gyText" @change="handleFormChange">
						<a-select-option v-for="(item) of availableGongyi" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="margin-top:8px;" type="primary" @click="addGY" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>

				<div ref="dragContainerGY" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of gyList" :key="item.tagId" :data-tag-id="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<div class="right" v-if="baseInfo.lang !== 'EN'" @click="deletePaperSizegy(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00',cursor:'pointer' }" type="delete" />
						</div>
					</div>
				</div>
			</a-form-item>

			<!-- 只有工厂有 -->
			<!-- 工厂地址 -->
			<a-form-item v-if="ifFacOrBr=='1'" label="工厂地址">
				<a-cascader v-if="baseInfo.lang !== 'EN'"  v-decorator="['cityAddress', { rules: ifFacOrBr === '1' ? [{ required: true, message: '请选择工厂地址' }] : [] }]" :field-names="{ label: 'text', value: 'value', children: 'children' }" :options="cityList" placeholder="工厂地址" @change="onChange"     :allowClear="false"/>
				<a-input v-else disabled :value="([baseInfo.province, baseInfo.city].filter(Boolean).join(' '))" placeholder="工厂地址（英文版只读）" />
			</a-form-item>
			<!-- 只有品牌有 -->
			<a-form-item v-if="ifFacOrBr=='2'" label="自有工厂">
				<a-radio-group v-model="hasOwnFactoryStatus" :disabled="baseInfo.lang === 'EN'">
					<a-radio :value="true">是</a-radio>
					<a-radio :value="false">否</a-radio>
				</a-radio-group>
				<a-input v-if="!hasOwnFactoryStatus" v-model="hasOwnFactorylabel" placeholder="请输入自有工厂标签" :disabled="baseInfo.lang === 'EN'" style="width:200px !important;display:inline-block;vertical-align:middle;margin-left:12px;" />
			</a-form-item>
			<!-- 只有品牌有：销售渠道 -->
			<a-form-item v-if="ifFacOrBr=='2'" label="销售渠道" :auto-link="false">
				<div v-decorator="['salesChannels', {
					  rules: [{ required: true, message: '请选择销售渠道' }]
					}]" style="display: none;"></div>
					<a-select placeholder="请选择销售渠道" show-search :disabled="baseInfo.lang === 'EN'"
						option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.scText" @change="handleFormChange">
						<a-select-option v-for="(item) of availableSalesChannels" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="margin-top:8px;" type="primary" @click="addSC" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>

				<div ref="dragContainerSC" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of scList" :key="item.tagId" :data-tag-id="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<div class="right" v-if="baseInfo.lang !== 'EN'" @click="deleteSC(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00',cursor:'pointer' }" type="delete" />
						</div>
					</div>
				</div>
			</a-form-item>
			<!-- 列表标签 -->
			<a-form-item :validate-status="partnerValidateStatus" :help="partnerHelp">
				<span slot="label"><span v-if="ifFacOrBr === '2'" style="color:#f5222d; margin-right: 4px;font-size: 14px;font-family: SimSun, sans-serif; line-height: 1;">*</span>列表标签 </span>
					<a-input v-model="partnerText"  placeholder="请输入列表标签" style="width:200px" />
					<a-button style="margin-top:8px" type="primary" @click="addPartner">+ 新增</a-button>
				<div ref="dragPartner" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of partnershipList" :key="item" :data-val="item">
						<span class="left">{{ item }}</span>
						<a-icon class="right" type="delete" style="color:red;cursor:pointer;font-size:20px" @click="delPartner(idx)" />
					</div>
				</div>

			</a-form-item>

			<!-- 主营标签 -->
			<a-form-item label="主营标签" :auto-link="false">
				<div v-decorator="['coreBusinessIds', {
					  rules: [{ required: true, message: '请选择主营标签' }]
					}]" style="display: none;"></div>
					<a-select placeholder="请选择主营标签" show-search :disabled="baseInfo.lang === 'EN'"
						option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.zyText" @change="handleFormChange">
						<a-select-option v-for="(item) of availableZhuying" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="margin-top:8px;" type="primary" @click="addZY" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>

				<div ref="dragContainerBQ" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of zyList" :key="item.id" :data-id="item.id">
						<span class="left">{{ item.name }}</span>
						<!-- 删除按钮 -->
						<div class="right" v-if="baseInfo.lang !== 'EN'" @click="deletePaperSizeZY(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00',cursor:'pointer' }" type="delete" />
						</div>
						<!-- 主营标签复选框 -->
						<label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
								<input type="checkbox" :checked="item.flag" :disabled="baseInfo.lang === 'EN' || (!item.flag && zyCheckedCount >= 3)" @change="handleFlagChange(item)" />
						</label>
				</div>
			</div>
			</a-form-item>

			<!-- 工厂面积 -->
			<a-form-item v-if="ifFacOrBr=='1'" label="工厂面积">
				<!-- <a-input v-decorator="['area', { rules: [{ required: true, message: '请输入工厂面积' }] }]"
					@input="handleFormChange" /> -->
				<a-input :disabled="baseInfo.lang === 'EN'" v-decorator="[
						'area',
						{
							rules: [
							{
								required: true,
								// 自定义校验，只有ifFacOrBr为1才强制必填
								validator: (rule, value, callback) => {
								if (this.ifFacOrBr === '1' && !value) {
									return callback('请输入工厂面积')
								}
								callback()
								}
							}
							]
						}
						]" @input="handleFormChange" placeholder="请输入工厂面积" addonAfter="m²" />
			</a-form-item>

			<a-form-item :wrapper-col="{ span: 24 }" style="text-align: center;">
				<a-button type="primary" html-type="submit" size="large">
					保存
				</a-button>
			</a-form-item>
		</a-form>
	</div>
</template>

<script>
	import Sortable from 'sortablejs'

	import {
		ossUpload
	} from "../../../utils/oss";
	// 注意路径：根据你的目录结构，从组件文件到json文件的相对路径
	// 正确路径：从组件往上跳 3 级，到 src，再进 assets/json
	import cityData from '../../../assets/json/citys_with_en.json'
	//
	import {
		factoryBaseInfoApi
	} from "../../../api/index";
	export default {
		name: "BaseInfoTab",
		props: {
			initialData: Object,
			companyList: { // （工厂列表）
				type: Array,
				default: () => []
			},
			pinleiList: { // 品类（工厂）
				type: Array,
				default: () => []
			},
			gongyiList: { // 工艺（工厂）
				type: Array,
				default: () => []
			},
			salesChannelsList: { // 销售渠道（品牌）
				type: Array,
				default: () => []
			},
			zhuyingList: { // 主营（工厂）
				type: Array,
				default: () => []
			},
			ifFacOrBr: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				businessLangId: 0,
				form: this.$form.createForm(this),
				// 本地表单数据
				baseInfo: { factoryImages: [] },
				hasOwnFactoryStatus: true,
				hasOwnFactorylabel: '',
				// 原始数据（用于对比是否修改）
				originBaseInfo: {},
				list: [],
				categoryIdsList: [],
				plList: [], //品类的回显
				gyList: [], //工艺的回显
				scList: [], //销售渠道的回显
				zyList: [],
				plText: 0,
				gyText: 0,
				scText: 0,
				zyText: 0,
				uploadingThumbnail: false,
				uploadingImage: false,
				cityList: cityData,
				partnershipList: [],
				partnerText: "",
				partnerValidateStatus: "",
				partnerHelp: "",
				sortableInstances: [],
			};
		},
		watch: {
			// 监听父组件数据更新 → 自动回填
			initialData: {
				deep: true,
				immediate: true,
				handler(val) {
					if (val) {
						this.initFormData(val);
					}
				}
			},
			pinleiList: {
				deep: true,
				handler() {
					this.syncCategoryList();
				}
			},
			gongyiList: {
				deep: true,
				handler() {
					this.syncCraftsmanshipList();
				}
			},
			salesChannelsList: {
				deep: true,
				handler() {
					this.syncSalesChannelList();
				}
			},
			// 详情和标签字典并行加载，字典后到时需要再次回填主营标签
			zhuyingList: {
				deep: true,
				handler() {
					this.syncCoreBusinessList();
				}
			},
			// 英文版禁用拖拽
			'baseInfo.lang'(newVal, oldVal) {
				this.applySortableDisabled();
			}
		},
		mounted() {
			this.initAllDrag()
		},
		computed: {
			zyCheckedCount() {
			  return this.zyList.filter(item => item.flag).length
			},
			availablePinlei() {
				const addedIds = this.plList.map(item => String(item.tagId));
				return this.pinleiList.filter(item => !addedIds.includes(String(item.tagId)));
			},
			availableGongyi() {
				const addedIds = this.gyList.map(item => String(item.tagId));
				return this.gongyiList.filter(item => !addedIds.includes(String(item.tagId)));
			},
			availableSalesChannels() {
				const addedIds = this.scList.map(item => String(item.tagId));
				return this.salesChannelsList.filter(item => !addedIds.includes(String(item.tagId)));
			},
			availableZhuying() {
				const addedIds = this.zyList.map(item => String(item.id));
				return this.zhuyingList.filter(item => !addedIds.includes(String(item.tagId)));
			},
		},
		methods: {
			mapSavedIds(value, source, idKey, separator) {
				if (!value) return [];
				const ids = String(value).split(separator).filter(Boolean);
				const itemMap = {};
				source.forEach(item => {
					itemMap[String(item[idKey])] = item;
				});
				return ids.map(id => itemMap[String(id)]).filter(Boolean);
			},
			syncCategoryList() {
				this.plList = this.mapSavedIds(this.baseInfo.categoryIds, this.pinleiList, 'tagId', ',');
			},
			syncCraftsmanshipList() {
				this.gyList = this.mapSavedIds(this.baseInfo.craftsmanshipIds, this.gongyiList, 'tagId', ',');
			},
			syncSalesChannelList() {
				this.scList = this.mapSavedIds(this.baseInfo.salesChannels, this.salesChannelsList, 'tagId', ';');
			},
			parseCoreBusinessIds(value) {
				if (Array.isArray(value)) return value;
				if (typeof value !== 'string' || !value.trim()) return [];

				try {
					const parsed = JSON.parse(value);
					return Array.isArray(parsed) ? parsed : [];
				} catch (error) {
					console.warn('主营标签数据格式异常', error);
					return [];
				}
			},
			syncCoreBusinessList() {
				const savedItems = this.parseCoreBusinessIds(this.baseInfo.coreBusinessIds);
				const tagMap = {};
				this.zhuyingList.forEach(item => {
					tagMap[String(item.tagId)] = item;
				});

				this.zyList = savedItems
					.filter(item => item && item.id !== undefined && item.id !== null)
					.map(item => {
						const matched = tagMap[String(item.id)];
						return {
							id: item.id,
							// 字典尚未加载或标签已停用时，仍保留接口返回的名称
							name: matched ? matched.tagName : (item.name || ''),
							flag: item.flag === true || item.flag === 1 || item.flag === 'true'
						};
					});
			},
			initFormData(data) {
				if (!data) return;

				this.baseInfo = JSON.parse(JSON.stringify(data || {}));
				this.hasOwnFactoryStatus = this.baseInfo.hasOwnFactoryStatus !== false;
				this.hasOwnFactorylabel = this.baseInfo.hasOwnFactorylabel || '';
				if (this.baseInfo.factoryImage && typeof this.baseInfo.factoryImage === 'string') {
				this.baseInfo.factoryImages = this.baseInfo.factoryImage.split(',').filter(Boolean);
			} else {
				this.baseInfo.factoryImages = [];
			}
			if (this.baseInfo.businessLangId) {
					this.businessLangId = this.baseInfo.businessLangId
				}


				this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
				// ==============================================
				// antd 表单赋值
				// ==============================================
				this.$nextTick(() => {
					this.form.setFieldsValue({
						businessId: this.baseInfo.businessId || undefined,
						factoryThumbnail: this.baseInfo.factoryThumbnail,
						factoryImage: this.baseInfo.factoryImages,
						categoryIds: this.baseInfo.categoryIds || undefined,
						craftsmanshipIds: this.baseInfo.craftsmanshipIds || undefined,
						salesChannels: this.baseInfo.salesChannels || undefined,
						coreBusinessIds: this.baseInfo.coreBusinessIds || undefined,
						cityAddress: this.baseInfo.provinceCode ? [this.baseInfo.provinceCode, this.baseInfo.cityCode] : [],
						area: this.baseInfo.businessArea || undefined,
					});
				});

				// ==============================================
				// 回显品类、工艺、主营、标签
				// ==============================================
				this.syncCategoryList();
				this.syncCraftsmanshipList();
				this.syncSalesChannelList();

				this.syncCoreBusinessList();
				this.partnershipList = this.baseInfo.indexTags
					? this.baseInfo.indexTags.split(';').filter(Boolean)
					: [];
				this.partnerValidateStatus = '';
				this.partnerHelp = '';

				this.$emit('dirty', false);
			},
			// 英文版禁用拖拽
			applySortableDisabled() {
				const disabled = this.baseInfo.lang === 'EN'
				this.sortableInstances.forEach(s => {
					if (s && typeof s.option === 'function') {
						s.option('disabled', disabled)
					}
				})
			},
			initAllDrag() {
				// 品类
				this.createDrag('dragContainerPL', this.plList)
				// 工艺
				this.createDrag('dragContainerGY', this.gyList)
				// 销售渠道
				this.createDrag('dragContainerSC', this.scList)
				// 主营标签
				this.createDrag('dragContainerBQ', this.zyList)
				// 列表标签
				this.createDrag('dragPartner', this.partnershipList)
			},
			// 拖拽通用方法
			createDrag(refName, list) {
				this.$nextTick(() => {
					const el = this.$refs[refName]
					if (!el) return

					const sortable = Sortable.create(el, {
						animation: 150,
						draggable: '.size_item',
						ghostClass: 'sort-ghost',

						onEnd: (evt) => {
							// 重要：不用闭包传入的旧 list，通过 refName 实时读取当前数据数组
							// （闭包中的 list 在 initAllDrag 时捕获，可能指向被替换的旧空数组）
							const listNameMap = {
								dragContainerPL: 'plList',
								dragContainerGY: 'gyList',
								dragContainerSC: 'scList',
								dragContainerBQ: 'zyList',
								dragPartner: 'partnershipList',
							}
							const list = this[listNameMap[refName]]
							// 从 DOM 中按实际视觉顺序重新读取列表
							// 不使用 oldIndex/newIndex，因为它们可能与 Vue 的 v-for key 不同步
							const domEl = this.$refs[refName]
							if (!domEl) return
							const items = domEl.querySelectorAll('.size_item')
							const attrMap = {
								dragContainerPL: 'tag-id',
								dragContainerGY: 'tag-id',
								dragContainerSC: 'tag-id',
								dragContainerBQ: 'id',
								dragPartner: 'val',
							}
							const attrName = attrMap[refName]
							const idKeyMap = {
								dragContainerPL: 'tagId',
								dragContainerGY: 'tagId',
								dragContainerSC: 'tagId',
								dragContainerBQ: 'id',
							}
							const idKey = idKeyMap[refName]
							// 建立 ID 到数据项的映射
							const idToItem = {}
							list.forEach(item => {
								const id = refName === 'dragPartner' ? item : item[idKey]
								idToItem[id] = item
							})
							// 按 DOM 顺序重建列表
							const newList = []
							items.forEach(domItem => {
								const id = domItem.getAttribute('data-' + attrName)
								if (idToItem[id] !== undefined) {
									newList.push(idToItem[id])
								}
							})
							// 替换原列表
							list.splice(0, list.length, ...newList)
							// 拖拽后更新对应的 baseInfo 和表单值
							this.afterDragUpdate(refName)
						},
					})
					if (['dragContainerPL', 'dragContainerGY', 'dragContainerSC', 'dragContainerBQ'].includes(refName)) {
						this.sortableInstances.push(sortable)
						sortable.option('disabled', this.baseInfo.lang === 'EN')
					}
				})
			},
			afterDragUpdate(refName) {
				switch (refName) {
					case 'dragContainerPL':
						this.baseInfo.categoryIds = this.plList.map(item => item.tagId).join(',');
						this.form.setFieldsValue({ categoryIds: this.baseInfo.categoryIds });
						break;
					case 'dragContainerGY':
						this.baseInfo.craftsmanshipIds = this.gyList.map(item => item.tagId).join(',');
						this.form.setFieldsValue({ craftsmanshipIds: this.baseInfo.craftsmanshipIds });
						break;
					case 'dragContainerSC':
						this.baseInfo.salesChannels = this.scList.map(item => item.tagId).join(';');
						this.form.setFieldsValue({ salesChannels: this.baseInfo.salesChannels });
						break;
					case 'dragContainerBQ':
						this.baseInfo.coreBusinessIds = JSON.stringify(this.zyList);
						this.form.setFieldsValue({ coreBusinessIds: this.baseInfo.coreBusinessIds });
						break;
					// dragPartner: partnershipList 直接在 saveData 中用 this.partnershipList.join(';')，数组本身已更新
				}
			},
			onChange(value, selectedOptions) {
				this.baseInfo.province = selectedOptions[0].text
				this.baseInfo.provinceCode = selectedOptions[0].value
				this.baseInfo.city = selectedOptions[1].text
				this.baseInfo.cityCode = selectedOptions[1].value
				this.baseInfo.provinceEn = selectedOptions[0].en
				this.baseInfo.cityEn = selectedOptions[1].en
			},
			filterBusiness(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			deleteFactoryImage(index) {
				this.baseInfo.factoryImages.splice(index, 1);
				this.form.setFieldsValue({ factoryImage: this.baseInfo.factoryImages });
			},
			validateFactoryImage(rule, value, callback) {
				if (!this.baseInfo.factoryImages || this.baseInfo.factoryImages.length === 0) {
					callback('请至少上传一张头图');
				} else {
					callback();
				}
			},
			// ======================
			// 输入型：权威合作
			// ======================
			addPartner() {
				if (!this.partnerText) return;
				this.partnershipList.push(this.partnerText);
				this.partnerText = '';
				this.partnerValidateStatus = '';
				this.partnerHelp = '';
			},
			delPartner(idx) {
				this.partnershipList.splice(idx, 1);
				this.partnerValidateStatus = '';
				this.partnerHelp = '';
			},
			// ======================
			// 表单任何变化 → 通知父组件
			// ======================
			handleFormChange(isUserAction) {
				const isModified = JSON.stringify(this.baseInfo) !== JSON.stringify(this.originBaseInfo);
				this.$emit("dirty", isModified || isUserAction);
			},

			// ======================
			// 上传缩略图
			// ======================
			handleUploadThumbnail(e) {
				const file = e.target.files[0];
				if (!file) return;
				if (file.size > 3 * 1024 * 1024) {
					this.$message.warning('图片大小不能超过3M');
					e.target.value = '';
					return;
				}
				this.uploadingThumbnail = true;
				ossUpload(file, '', 'image/').then(res => {
					this.baseInfo.factoryThumbnail = res.url;
					this.form.setFieldsValue({ factoryThumbnail: res.url });
					e.target.value = '';
				}).catch(err => {
					console.error(err);
				}).finally(() => {
					this.uploadingThumbnail = false;
				});
			},

			// ======================
			// 上传头图
			// ======================
			handleUploadImage(e) {
				let files = Array.from(e.target.files);
				if (!files.length) return;
				// 品牌类型：直接替换，不限数量；工厂类型：最多3张
				if (this.ifFacOrBr == '1') {
					const maxCanAdd = 3 - (this.baseInfo.factoryImages || []).length;
					if (maxCanAdd <= 0) {
						this.$message.warning('最多上传3张图片');
						e.target.value = '';
						return;
					}
					if (files.length > maxCanAdd) {
						this.$message.warning('只能再选 ' + maxCanAdd + ' 张，已自动截取前 ' + maxCanAdd + ' 张');
					}
					files = files.slice(0, maxCanAdd);
				}
				const toUpload = files;
				for (const f of toUpload) {
					if (f.size > 3 * 1024 * 1024) {
						this.$message.warning('图片大小不能超过3M');
						e.target.value = '';
						return;
					}
				}
				this.uploadingImage = true;
				const uploads = toUpload.map(f => ossUpload(f, '', 'image/'));
				Promise.all(uploads).then(results => {
					if (this.ifFacOrBr == '1') {
					this.baseInfo.factoryImages.push(...results.map(r => r.url));
				} else {
					this.baseInfo.factoryImages = results.map(r => r.url);
				}
					this.form.setFieldsValue({ factoryImage: this.baseInfo.factoryImages });
					e.target.value = '';
				}).catch(err => {
					console.error(err);
				}).finally(() => {
					this.uploadingImage = false;
				});
			},

			// ======================
			// 新增品类
			// ======================
			addPL() {
				const hasFactory = this.plList.some(item => item.tagId == this.baseInfo.plText);
				if (hasFactory) {
					this.$message.warning('已添加该工厂');
					return;
				} else {
					const factory = this.pinleiList.find(item => item.tagId == this.baseInfo.plText);
					if (factory) {
						this.plList.push(factory);
						this.baseInfo.categoryIds = this.plList.map(item => item.tagId).join(',');
						this.form.setFieldsValue({
							categoryIds: this.baseInfo.categoryIds
						});
						// 新增后清空下拉选择
						this.baseInfo.plText = undefined;
						this.form.setFieldsValue({ plText: undefined });
					}
				}
			},

			// ======================
			// 删除品类
			// ======================
			deletePaperSize(index) {
				this.plList.splice(index, 1);
				this.baseInfo.categoryIds = this.plList.map(item => item.tagId).join(',');
				this.form.setFieldsValue({
					categoryIds: this.baseInfo.categoryIds
				});
				this.handleFormChange();
			},

			// ======================
			// 新增工艺
			// ======================
			addGY() {
				const hasFactory = this.gyList.some(item => item.tagId == this.baseInfo.gyText);
				if (hasFactory) {
					this.$message.warning('已添加该工厂');
					return;
				} else {
					const factory = this.gongyiList.find(item => item.tagId == this.baseInfo.gyText);
					if (factory) {
						this.gyList.push(factory);
						this.baseInfo.craftsmanshipIds = this.gyList.map(item => item.tagId).join(',');
						this.form.setFieldsValue({
							craftsmanshipIds: this.baseInfo.craftsmanshipIds
						});
						// 新增后清空下拉选择
						this.baseInfo.gyText = undefined;
						this.form.setFieldsValue({ gyText: undefined });

					}
				}
			},
			// ======================
			// 删除工艺
			// ======================
			deletePaperSizegy(index) {
				this.gyList.splice(index, 1)
				this.baseInfo.craftsmanshipIds = this.gyList.map(item => item.tagId).join(',');
				this.form.setFieldsValue({
					craftsmanshipIds: this.baseInfo.craftsmanshipIds
				});
				this.handleFormChange();
			},

			// ======================
			// 新增销售渠道
			// ======================
			addSC() {
				const hasItem = this.scList.some(item => item.tagId == this.baseInfo.scText);
				if (hasItem) {
					this.$message.warning('已添加该销售渠道');
					return;
				} else {
					const item = this.salesChannelsList.find(item => item.tagId == this.baseInfo.scText);
					if (item) {
						this.scList.push(item);
						this.baseInfo.salesChannels = this.scList.map(item => item.tagId).join(';');
						this.form.setFieldsValue({
							salesChannels: this.baseInfo.salesChannels
						});
						this.baseInfo.scText = undefined;
						this.form.setFieldsValue({ scText: undefined });
					}
				}
			},

			// ======================
			// 删除销售渠道
			// ======================
			deleteSC(index) {
				this.scList.splice(index, 1)
				this.baseInfo.salesChannels = this.scList.map(item => item.tagId).join(';');
				this.form.setFieldsValue({
					salesChannels: this.baseInfo.salesChannels
				});
				this.handleFormChange();
			},


			// ======================
			// 新增主营
			// ======================
			addZY() {
				const hasFactory = this.zyList.some(item => item.id == this.baseInfo.zyText);
				if (hasFactory) {
					this.$message.warning('已添加该工厂');
					return;
				} else {
					const factory = this.zhuyingList.find(item => item.tagId == this.baseInfo.zyText);
					if (factory) {
						// 先把找到的factory对象，转成后端要的格式：{ id, name, flag }
						const newItem = {
							id: factory.tagId,
							name: factory.tagName,
							flag: false // 默认勾选，也可以根据你的业务改
						};
						this.zyList.push(newItem);
						this.baseInfo.coreBusinessIds = JSON.stringify(this.zyList);
						this.form.setFieldsValue({
							coreBusinessIds: this.baseInfo.coreBusinessIds
						});
					// 新增后清空下拉选择
					this.baseInfo.zyText = undefined;
					this.form.setFieldsValue({ zyText: undefined });
					}
				}
			},
			// ======================
			// 删除主营
			// ======================
			deletePaperSizeZY(index) {
				this.zyList.splice(index, 1);
				this.baseInfo.coreBusinessIds = JSON.stringify(this.zyList);
				this.form.setFieldsValue({
					coreBusinessIds: this.baseInfo.coreBusinessIds
				});
				this.handleFormChange();
			},

			// 复选框状态变化时的回调（可选）
			handleFlagChange(item) {
				// 手动切换 true <-> false
				item.flag = !item.flag;
				this.baseInfo.coreBusinessIds = JSON.stringify(this.zyList);
				this.form.setFieldsValue({ coreBusinessIds: this.baseInfo.coreBusinessIds });
				this.handleFormChange(true);
			},


			// ======================
			// 表单提交（手动点击）
			// ======================
			handleSubmit() {
				var self = this;
				// 品牌类型：列表标签校验
                // 主营标签校验：至少勾选1个
                if (self.zyCheckedCount === 0) {
                  this.$message.warning('请至少勾选1个主营标签')
                  return;
                }
                // 品牌类型：列表标签校验
                if (self.ifFacOrBr === '2' && (!self.partnershipList || self.partnershipList.length === 0)) {
                  this.partnerValidateStatus = 'error';
                  this.partnerHelp = '请添加列表标签';
                } else {
                  this.partnerValidateStatus = '';
                  this.partnerHelp = '';
                }

				this.form.validateFields(function(err, values) {
					if (err && self.ifFacOrBr === '2' && err.cityAddress) {
						delete err.cityAddress;
						self.form.setFields({
							cityAddress: {
								value: values.cityAddress || [],
								errors: null
							}
						});
					}
					if (err && Object.keys(err).length > 0 || self.partnerValidateStatus === 'error') {
						return;
					}
					if (!err || Object.keys(err).length === 0) {
						self.saveData(values);
					}
				});
			},

			// ======================
			// 保存方法（父组件调用）
			// ======================
			async saveData(values) {
				const isEnglish = this.baseInfo.lang === 'EN';
				factoryBaseInfoApi({
						"businessLangId": this.businessLangId,
						"businessId": values.businessId,
						"province": isEnglish ? null : this.baseInfo.province,
						"city": isEnglish ? null : this.baseInfo.city,
						"provinceEn": isEnglish ? null : this.baseInfo.provinceEn,
						"cityEn": isEnglish ? null : this.baseInfo.cityEn,
						"provinceCode": isEnglish ? null : this.baseInfo.provinceCode,
						"cityCode": isEnglish ? null : this.baseInfo.cityCode,
						"factoryThumbnail": values.factoryThumbnail,
						"factoryImage": (values.factoryImage || []).join(","),
						// 以下排序字段全部从数据数组获取，不依赖表单 validateFields（保证拖拽后的顺序正确）
						"categoryIds": this.plList.map(item => item.tagId).join(','),
						"craftsmanshipIds": this.gyList.map(item => item.tagId).join(','),
						"indexTags": this.partnershipList.join(';'),
						"coreBusinessIds": JSON.stringify(this.zyList),
						"businessArea": values.area,
						"hasOwnFactoryStatus": this.hasOwnFactoryStatus,
						"hasOwnFactorylabel": this.hasOwnFactorylabel || "",
						"salesChannels": this.scList.map(item => item.tagId).join(';'),
					})
					.then((res) => {
						if (res.resultStatus) {
							const isNew = !this.baseInfo.businessLangId;
							this.$message.success(
								isNew ? "新增成功" : "编辑成功"
							);
							// 保存成功后更新原始数据，清除未保存状态
							this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
							this.$emit("dirty", false);
							// 新增成功，更新本地 businessLangId 防止重复保存时 ID 仍为 0
							if (isNew && res.resultData) {
								this.businessLangId = res.resultData;
								this.baseInfo.businessLangId = res.resultData;
							}
							// 新增成功，回传ID让父组件启用其他tab
							this.$emit("saved", { businessLangId: res.resultData });
						} else {}
					})
					.catch((error) => {})
					.finally(() => {})

			},
		},
	};
</script>

<style scoped lang="less">
	.product-tab {
		padding: 16px;
	}

	.mt12 {
		margin-top: 12px;
	}

	.mr12 {
		margin-right: 12px;
	}

	.size_item {
		min-height: 50px;
		height: auto;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 10px;

		.left {
			flex: 1;
			padding-left: 10px;
			word-break: break-all;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.ant-form-item {
		margin-bottom: 10px !important;
	}

	// 统一所有下拉框、输入框、级联选择器宽度
	.ant-select,
	.ant-cascader,
	.ant-input {
		width: 100% !important;
	}
</style>
